import { Avatar, Button, Dialog, DialogContent, DialogTitle, FormControl, FormControlLabel, FormHelperText, Grid, makeStyles, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@material-ui/core";
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { withStyles } from "@material-ui/styles";
import clsx from 'clsx';
import AdminTitle from "components/admin/smart-visa/AdminTitle";
import AdminTitle2 from "components/admin/smart-visa/AdminTitle2";
import { StyleCheckbox } from "components/request-document/components/Commons";
import { format } from "date-fns";
import { useFormik } from "formik";
import { boiDepartmentId } from "libs/configs/constant";
import { getErrorMessage, isError } from "libs/utils/form";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getEmployeeList } from "redux/modules/employeeSlice";
import { getTransferJob, getTransferJobDetail, transferJobs } from "redux/modules/transferJobSlice";
import * as yup from "yup";
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  content: {
    marginTop: 30
  },
  warpSubHeader: {
    marginTop: 20,
    display: "flex", justifyContent: "space-between", alignItems: "center"
  },
  buttonDialogSave: {
    width: '100%',
    margin: '15px 5px'
  },
  table: {
    minWidth: 700,
  },
  tableHead: {
    backgroundColor: '#F1F3F9',
    color: '#8898AA',
    textAlign: 'center'
  },
  tableHead2: {
    backgroundColor: '#F1F3F9',
    color: '#8898AA',
    textAlign: 'center',
    padding: 0
  },
  iconStatus: {
    color: '#2DCE98',
    marginRight: 5
  },
  warpButtonDetail: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  center: {
    textAlign: 'center'
  },
  btnRequest: {
    color: 'white',
    border: '1px solid #00D0FF',
    backgroundColor: ' #00D0FF',
    marginRight: 10,
    width: 100
  },
  wrapTable: {

  },
  warpButtonSave: {
    textAlign: 'right',
    marginTop: 30
  },
  buttonSave: {
    marginLeft: 5,
    width: 120
  },
  warpDialog: {

    padding: "30px", width: "100%", minHeight: "200px"
  },
  warpFormControl: {
    textAlign: 'right'
  },
  wrapTransferIcon: {
    display: "flex", flexDirection: "column"
  },
  dtitle: {
    display: "flex", justifyContent: "space-between",
    alignItems: 'center',
    width: '100%'
  },
  wrapTransferRow: {
  },
  fullformControl: {
    width: '100%'
  },
  titleDialog: {
    color: "#172B4D", fontSize: "20px", fontWeight: "500"
  },
  rowT1: {
    display: "flex", textAlign: "center", alignItems: "center", justifyContent: 'center'
  },
  iconTransfer: {
    color: '#007BFF',
    border: '1px solid gray',
    backgroundColor: 'white',
    marginTop: 10,
    cursor: 'pointer'
  },
  formControl: {
    width: '100%'
  },

}));


function ConfigDialog(props) {
  const rows = [
    ['T0001', 'ขออนุบัติตำแหน่งคนต่างด้าว', '28/10/2021', '13.00 น'],
    ['T0001', 'ขอบรรจุต่างด้วและขออนุญาตครอบครัวเข้ามาาในประเกศ (Oparator พรือเทส์เคียง)', '28/10/2021', '13.00 น'],

  ];
  const dispatch = useDispatch();
  const classes = useStyles();
  const { onClose, open, isTransfer, data } = props;

  const { list: employees } = useSelector((state) => state.employee);
  // const { detail: joblist } = useSelector((state) => state.transferJob);


  const [leftJobs, setLeftJobs] = React.useState([]);
  const [rightJobs, setRightJobs] = React.useState([]);


  const [scroll, setScroll] = React.useState('paper');

  useEffect(async () => {
    if (open) {
      // setLeftJobs([])
      // setRightJobs([])
      const bodyDetail = {
        empIds: [data?.empFromId, data?.empToId].filter(x => x)
      }
      const res = await dispatch(getTransferJobDetail(bodyDetail));

      if (res.payload) {
        if (data?.empFromId) {
          formik.setFieldValue('empFromId', data?.empFromId);
          formik.setFieldValue('empToId', '');
          setLeftJobs(res.payload);
          setRightJobs([]);
        }
        if (data?.empToId) {
          formik.setFieldValue('empToId', data?.empToId);
          formik.setFieldValue('empFromId', '');
          setRightJobs(res.payload);
          setLeftJobs([]);
        }
      }
    }
  }, [open]);

  useEffect(async () => {
    const body = {
      departmentId: boiDepartmentId
    }
    await dispatch(getEmployeeList(body));
  }, []);


  const handleListItemClick = () => {
    onClose({});
  };

  const handleClose = (value = null) => {
    onClose(value);
  };


  const validationSchema = yup.object({
    empFromId: yup.string().required("Employee is required."),
    empToId: yup.string().required("Employee is required.")
  });

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      empFromId: data?.empFromId,
      empToId: data?.empToId,
    },
    onSubmit: async (values) => {

      const body = {

      };

      onClose(body);
    },
  });


  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} fullWidth
      maxWidth="xl" className={classes.warpDialog}>
      <DialogTitle id="simple-dialog-title">
        <div className={classes.dtitle}>
          <div>
            โอนงานเจ้าหน้าที่
          </div>
          <div>
            <Button variant="outlined" size="medium" color="info" className={classes.buttonSave} onClick={handleClose}>
              ปิด
            </Button>

            <Button variant="outlined" size="medium" color="primary" className={classes.buttonSave} onClick={() => {
              setLeftJobs([]);
              setRightJobs([]);
              formik.setFieldValue('empFromId', '')
              formik.setFieldValue('empToId', '')
            }}>
              ล้าง
            </Button>

            <Button variant="contained" size="medium" color="primary" className={classes.buttonSave} onClick={async () => {

              if (!formik.values.empFromId || !formik.values.empToId) {
                alert('กรุณาเลือกพนักงาน');
                return;
              }
              const transfered = rightJobs.filter(x => x.transferEmpId && x.empId != x.transferEmpId);

              const body = {
                list: transfered.map(x => ({
                  draftId: x.draftId,
                  userFromId: x.empId,
                  userToId: x.transferEmpId
                }))
              }
              await dispatch(transferJobs(body));
              handleClose(true);
            }}>
              บันทึก
            </Button>
          </div>
        </div>


      </DialogTitle>
      <DialogContent dividers={scroll === 'paper'}>
        <div className={classes.warpRowDialog}>

          <Grid container className={classes.wrapTransferRow}>

            <Grid item xs={12} sm={5} className={classes.wrapTransfer}>
              <div className={classes.titleDialog}>
                โอนงานออก
              </div>
              <div style={{ marginTop: 5 }}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <Select
                    name="empFromId"
                    className={classes.root}
                    value={formik.values.empFromId}
                    // onChange={formik.handleChange}
                    onChange={async (e) => {
                      formik.setFieldValue('empFromId', e.target.value);
                      const bodyDetail = {
                        empIds: [e.target.value]
                      }
                      const res = await dispatch(getTransferJobDetail(bodyDetail));
                      console.log(res);
                      setLeftJobs(res.payload);
                    }}
                    onBlur={formik.handleBlur}
                    error={isError("empFromId", formik)}
                  >
                    {employees
                      .map((v) => v)
                      .filter(x => x.empId != formik.values.empToId)
                      .sort(sortByName("employeeFistName"))
                      .map((p) => (
                        <MenuItem
                          key={p.empId}
                          value={p.empId}
                        >
                          {p.employeeFistName}    {p.employeeLastName}
                        </MenuItem>
                      ))}
                  </Select>
                  <FormHelperText
                    error={isError("empFromId", formik)}
                  >
                    {getErrorMessage(
                      "empFromId",
                      formik
                    )}
                  </FormHelperText>
                </FormControl>
              </div>
              <div style={{ marginTop: 10, textAlign: 'right' }}>
                <span style={{ marginRight: 10 }}>
                  งานปัจจุบัน: <span style={{ color: '#2dce98' }}>{leftJobs.length}</span>
                </span>
                <span>
                  งานเกินเวลา: <span style={{ color: 'orangered' }}>{leftJobs.filter(x => x.overdue).length}</span>
                </span>
              </div>

              <div style={{ marginTop: 15 }}>
                <div className={clsx(classes.warpData, classes.wrapTable)}>
                  <TableContainer component={Paper}>
                    <Table size="small" aria-label="customized table">
                      <TableHead >
                        <TableRow>
                          <StyledTableCell className={classes.tableHead2}>
                            <FormControlLabel
                              control={
                                <StyleCheckbox
                                  name="leftCheck"
                                  onChange={(e) => {
                                    let lefts = [...leftJobs.map(x => ({ ...x, selected: e.target.checked }))];
                                    setLeftJobs(lefts);
                                  }}
                                />
                              }
                            />
                          </StyledTableCell>
                          <StyledTableCell className={classes.tableHead2}>เลขคำขอ</StyledTableCell>
                          <StyledTableCell className={classes.tableHead2}>รายการคำขอ</StyledTableCell>
                          <StyledTableCell className={classes.tableHead2}>วันครบกำหนด</StyledTableCell>

                        </TableRow>
                      </TableHead>
                      <TableBody>

                        {
                          leftJobs.map((r, index) => (
                            <StyledTableRow key={index}>
                              <StyledTableCell component="th" scope="row" className={classes.center}>
                                <FormControlLabel
                                  control={
                                    <StyleCheckbox
                                      checked={r?.selected || false}
                                      onChange={(event) => {
                                        const _leftJobs = leftJobs.map((item, index2) => (index === index2) ? { ...item, selected: event.target.checked } : item)
                                        setLeftJobs(_leftJobs);
                                      }}
                                    />
                                  }
                                />
                              </StyledTableCell>
                              <StyledTableCell className={classes.center}>{r.smartNo}</StyledTableCell>
                              <StyledTableCell className={classes.center}>{r.description}</StyledTableCell>
                              <StyledTableCell className={classes.center}>
                                {format(new Date(r.smartDate), "yyyy-MM-dd")}
                              </StyledTableCell>

                            </StyledTableRow>
                          ))
                        }



                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={2} className={classes.rowT1}>
              <div className={classes.wrapTransferIcon}>
                <div className={classes.wrapTransferIcon}>
                  <Avatar className={classes.iconTransfer}>
                    <KeyboardArrowLeftIcon onClick={() => {
                      if (!formik.values.empFromId) {
                        alert('กรุณาเลือกพนักงาน');
                        return;
                      }
                      let _rightJobs = [...rightJobs];
                      const _rightJobsSelected = _rightJobs.filter(x => x.selected);
                      const _rightJobsUnSelected = _rightJobs.filter(x => !x.selected);
                      setLeftJobs([...leftJobs, ..._rightJobsSelected.map(x => ({ ...x, transferEmpId: formik.values.empFromId }))]);
                      setRightJobs([..._rightJobsUnSelected]);
                    }} />
                  </Avatar>
                  <Avatar className={classes.iconTransfer}>
                    <KeyboardArrowRightIcon onClick={() => {
                      if (!formik.values.empToId) {
                        alert('กรุณาเลือกพนักงาน');
                        return;
                      }
                      let _leftJobs = [...leftJobs];
                      const _leftJobsSelected = _leftJobs.filter(x => x.selected);
                      const _leftJobsUnSelected = _leftJobs.filter(x => !x.selected);
                      setRightJobs([...rightJobs, ..._leftJobsSelected.map(x => ({ ...x, transferEmpId: formik.values.empToId }))]);
                      setLeftJobs([..._leftJobsUnSelected]);
                    }} />
                  </Avatar>
                </div>

              </div>

            </Grid>
            <Grid item xs={12} sm={5} className={classes.wrapTransfer} >
              <div className={classes.titleDialog}>
                โอนงานเข้า
              </div>
              <div style={{ marginTop: 5 }}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <Select
                    name="empToId"
                    className={classes.root}
                    value={formik.values.empToId}
                    // onChange={formik.handleChange}
                    onChange={async (e) => {
                      formik.setFieldValue('empToId', e.target.value);
                      const bodyDetail = {
                        empIds: [e.target.value]
                      }
                      const res = await dispatch(getTransferJobDetail(bodyDetail));
                      setRightJobs(res.payload);
                      console.log(res.payload);
                    }}
                    onBlur={formik.handleBlur}
                    error={isError("empToId", formik)}
                  >
                    {employees
                      .map((v) => v)
                      .filter(x => x.empId != formik.values.empFromId)
                      .sort(sortByName("employeeFistName"))
                      .map((p) => (
                        <MenuItem
                          key={p.empId}
                          value={p.empId}
                        >
                          {p.employeeFistName}    {p.employeeLastName}
                        </MenuItem>
                      ))}
                  </Select>
                  <FormHelperText
                    error={isError("empToId", formik)}
                  >
                    {getErrorMessage(
                      "empToId",
                      formik
                    )}
                  </FormHelperText>
                </FormControl>
              </div>
              <div style={{ marginTop: 10, textAlign: 'right' }}>
                {/* <span style={{ marginRight: 10 }}>
                  งานปัจจุบัน: <span style={{ color: '#2dce98' }}>20</span>
                </span>
                <span>
                  งานเกินเวลา: <span style={{ color: 'orangered' }}>10</span>
                </span> */}

                <span style={{ marginRight: 10 }}>
                  งานปัจจุบัน: <span style={{ color: '#2dce98' }}>{rightJobs.length}</span>
                </span>
                <span>
                  งานเกินเวลา: <span style={{ color: 'orangered' }}>{rightJobs.filter(x => x.overdue).length}</span>
                </span>
              </div>

              <div style={{ marginTop: 15 }}>
                <div className={clsx(classes.warpData, classes.wrapTable)}>
                  <TableContainer component={Paper}>
                    <Table size="small" aria-label="customized table">
                      <TableHead >
                        <TableRow>
                          <StyledTableCell className={classes.tableHead2}>
                            <FormControlLabel
                              control={
                                <StyleCheckbox
                                  name="rightCheck"
                                  onChange={(e) => {
                                    let rights = [...rightJobs.map(x => ({ ...x, selected: e.target.checked }))];
                                    setRightJobs(rights);
                                  }}
                                />
                              }
                            />
                          </StyledTableCell>
                          <StyledTableCell className={classes.tableHead2}>เลขคำขอ</StyledTableCell>
                          <StyledTableCell className={classes.tableHead2}>รายการคำขอ</StyledTableCell>
                          <StyledTableCell className={classes.tableHead2}>วันครบกำหนด</StyledTableCell>

                        </TableRow>
                      </TableHead>
                      <TableBody>

                        {
                          rightJobs.map((r, index) => (
                            <StyledTableRow key={index}>
                              <StyledTableCell component="th" scope="row" className={classes.center}>
                                <FormControlLabel
                                  control={
                                    <StyleCheckbox
                                      checked={r.selected || false}
                                      onChange={(event) => {
                                        const _rightJobs = rightJobs.map((item, index2) => (index === index2) ? { ...item, selected: event.target.checked } : item)
                                        setRightJobs(_rightJobs);
                                      }}
                                    />
                                  }
                                />
                              </StyledTableCell>
                              <StyledTableCell className={classes.center}>{r.smartNo}</StyledTableCell>
                              <StyledTableCell className={classes.center}>{r.description}</StyledTableCell>
                              <StyledTableCell className={classes.center}>
                                {format(new Date(r.smartDate), "yyyy-MM-dd")}
                              </StyledTableCell>

                            </StyledTableRow>
                          ))
                        }



                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>

      </DialogContent>
    </Dialog >
  );
}



function TransferJobPage() {

  const classes = useStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [isTransfer, setIsTransfer] = React.useState(true);
  const { list: empJobsList } = useSelector((state) => state.transferJob);

  const [searchKeyword, setSearchKeyword] = React.useState('');
  const [empName, setEmpName] = React.useState('');
  const [dialogData, setDialogData] = React.useState({});
  useEffect(async () => {
    await dispatch(getTransferJob());
  }, []);

  const handleTransfer = async (emp) => {


    // const bodyDetail = {
    //   empIds: [emp.empId]
    // }
    // await dispatch(getTransferJobDetail(bodyDetail));
    setDialogData({
      empFromId: emp.empId,
      empToId: null,
    })

    setOpen(true);
    setIsTransfer(true);
  }

  const handleReceive = async (emp) => {
    // const bodyDetail = {
    //   empIds: [emp.empId]
    // }
    // await dispatch(getTransferJobDetail(bodyDetail));
    setDialogData({
      empFromId: null,
      empToId: emp.empId,
    })

    setOpen(true);
    setIsTransfer(false);
  }

  const handleClose = async (value) => {
    console.log(value);
    setOpen(false);
    if (value) {
      await dispatch(getTransferJob());
    }
  };

  return (
    <Paper className={classes.paper}>
      <AdminTitle title="Setting" subTitle="โอนงานเจ้าหน้าที่" />
      <ConfigDialog open={open} onClose={handleClose} isTransfer={isTransfer} data={dialogData} />
      <div className={classes.warpSubHeader} >
        <AdminTitle2 subTitle="รายชื่อเจ้าหน้าที่" />

        <div>
          {/* <Button variant="contained" size="medium" color="primary" onClick={() => handleAddSurrogate()} className={classes.buttonDialogSave}>
            <AddIcon />
            เพิ่มผู้รักษาการแทน
          </Button> */}
          <FormControl variant="outlined" className={classes.formControl}>

            <TextField
              type="text"
              variant="outlined"
              placeholder="ค้นหาพนักงาน"
              className={classes.textField}
              onChange={(event) => {
                setSearchKeyword(event.target.value);
              }}
              name="emp_search"
            />
          </FormControl>
        </div>

      </div>
      <div className={classes.content}>
        <div className={clsx(classes.warpData, classes.wrapTable)}>
          <TableContainer>
            <Table className={classes.table} aria-label="customized table">
              <TableHead >
                <TableRow>
                  <StyledTableCell className={classes.tableHead}>#</StyledTableCell>
                  <StyledTableCell className={classes.tableHead}>First Name</StyledTableCell>
                  <StyledTableCell className={classes.tableHead}>Last Name</StyledTableCell>
                  <StyledTableCell className={classes.tableHead}>Position</StyledTableCell>
                  <StyledTableCell className={classes.tableHead}>จำนวนคำขอ</StyledTableCell>
                  <StyledTableCell className={classes.tableHead}>คำขอเกินเวลา</StyledTableCell>
                  <StyledTableCell className={classes.tableHead}>Action</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {empJobsList.filter(x =>
                  x.firstName.toLowerCase().indexOf(searchKeyword) > -1 ||
                  x.lastName.toLowerCase().indexOf(searchKeyword) > -1
                ).map((row, index) => (
                  <StyledTableRow key={row.name}>
                    <StyledTableCell component="th" scope="row" className={classes.center}> {index + 1}</StyledTableCell>
                    <StyledTableCell className={classes.center}>{row.firstName}</StyledTableCell>
                    <StyledTableCell className={classes.center}>{row.lastName}</StyledTableCell>
                    <StyledTableCell className={classes.center}>{row.position}</StyledTableCell>

                    <StyledTableCell className={classes.center}>{row.jobCount}</StyledTableCell>
                    <StyledTableCell className={classes.center}>{row.overdueCount}</StyledTableCell>
                    <StyledTableCell style={{ textAlign: 'center' }}>
                      <div className={classes.warpButtonDetail}>
                        <Button size="small" className={classes.btnRequest} onClick={() => {
                          handleTransfer(row);
                        }}>
                          โอนงาน
                        </Button>
                        <Button size="small" className={classes.btnRequest} onClick={() => {
                          handleReceive(row);

                        }}>
                          รับงาน
                        </Button>
                      </div>
                    </StyledTableCell>

                  </StyledTableRow>
                ))}

              </TableBody>
            </Table>
          </TableContainer>
        </div>

      </div>


    </Paper >
  );
}

export default TransferJobPage;

function sortByName(fileName) {
  return (a, b) => {
    const nameA = a[fileName]?.toUpperCase(); // ignore upper and lowercase
    const nameB = b[fileName]?.toUpperCase(); // ignore upper and lowercase

    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    // names must be equal
    return 0;
  };
}